import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DocxViewer from "../../../../components/DocxViewer/DocxViewer";

function DownLoadTemplateDialog({ open, onClose, policyData }) {
  if (!policyData) return null;

  const handleDownloadDocument = () => {
    if (!policyData?.policyFileName) return;

    const link = document.createElement("a");
    link.href = `${process.env.REACT_APP_POLICY_DOC_URL}/${policyData.policyFileName}`;
    link.download = policyData.policyFileName;
    link.click();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle fontWeight="bold">
        {`Regodit Template for ${policyData?.policyDisplayName || "policy"}`}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{ maxHeight: "400px", overflow: "hidden", borderRadius: "4px" }}
      >
        {/** hackish way of key to force re-render */}
        <Box sx={{ width: "100%", height: "400px" }}>
          {policyData?.policyFileName && (
            <DocxViewer
              fileUrl={`${process.env.REACT_APP_POLICY_DOC_URL}/${policyData.policyFileName}`}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button variant="contained" onClick={handleDownloadDocument}>
          Download Template
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DownLoadTemplateDialog;
